import { isLocalhost } from 'Lib/is-localhost/is-localhost';

class YaCaptcha {
    constructor() {
        this._widgetId = '';
        this._script = document.createElement('script');
        this._script.src = 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload';
        this._script.async = true;
        this._script.defer = true;

        this._script.onload = () => {
            console.log('YaCaptha - loaded');

            if (isLocalhost()) {
                this.key = 'ysc1_su1U2Qfhsqfufv8MwJ8utDHGULVqdse8q0gSBwGVf22baa55'; // ключ для локалки
            } else if (isLocalhost(true)) {
                this.key = 'ysc1_wYrDfBqnBILJiFbwzBYmW7A0aZ1MuUUsvBtgbdvF7342a03f'; // ключ для дева
            } else {
                this.key = 'ysc1_Y8wP8IAXiWglC3u9bsMEq7FUquzDsgAMfG82Hkb39e8adef2'; // ключ для прода
            }

            this._widgetId = window.smartCaptcha.render('captcha-container', {
                sitekey: this.key,
                invisible: true,
                hideShield: true,
                callback: YaCaptcha._callback,
            });
        };

        this._script.onerror = () => {
            console.error('YaCaptha - 404');
        };

        document.getElementsByTagName('body')[0].appendChild(this._script);
    }

    static currentForm = '';

    static _callback(token) {
        console.log(YaCaptcha.currentForm);
        YaCaptcha.currentForm.trigger('eksmoSubmitCaptcha', [token]);
    }

    renderYaCaptcha(form) {
        YaCaptcha.currentForm = form;
        window.smartCaptcha.execute(this._widgetId);
    }
}

export default new YaCaptcha();